export enum StageId {
	LOCAL = 'local',
	STAGING = 'staging',
	PRODUCTION = 'production',
}
